import { MicrositeBuyButton } from "@ubnt/store.core/lib/components/MicrositeBuyButton";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import styled, { createGlobalStyle, css } from "styled-components";
import { MicrositeHeading } from "../MicrositeHeading";

export const HeroContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  max-height: 880px;
  min-height: 880px;
  max-width: 3840px;
  background-color: #151a29;
  height: 100%;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    max-height: 640px;
    min-height: unset;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    max-height: 560px;
    min-height: 560px;
  }
`;

export const VideoGradientContainer = styled.div`
  width: 100%;
  position: relative;
  max-height: 880px;
  max-width: 3840px;
  height: 100%;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    max-height: 640px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    max-height: 560px;
  }
`;

export const BackgroundVideo = styled.video`
  height: 880px;
  width: 100%;
  object-fit: cover;
  position: static;
  left: 0;
  opacity: 1;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    height: 640px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    height: 560px;
    min-height: 560px;
    object-position: center;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  z-index: 3;
`;

export const Tab = styled.button`
  display: flex;
  align-items: flex-start;
  background: transparent;
  padding: 4px 0;
  outline: none;
  border: none;
  width: fit-content;
`;

export const TabLabel = styled.span<{ $isActive: boolean }>`
  color: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  line-height: 16px;
  text-align: left;
  text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
`;

export const Title = styled(MicrositeHeading)`
  h1 {
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 28px;
  color: ${({ theme }) => theme.colors.white};
  line-height: normal;
  text-align: center;
  text-wrap: balance;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 24px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 20px;
  }
`;

export const Content = styled.div`
  left: 0;
  padding: 0 16px;
  position: absolute;
  top: 48px;
  width: 100%;
  z-index: 3;
  opacity: 0;
  transform: translateY(15%);
`;

export const Gradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 433px;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(21, 26, 41, 0.75) 0%,
    rgba(21, 26, 41, 0.1) 81%,
    rgba(0, 0, 0, 0) 100%
  );
  z-index: 2;

  @media (${BREAKPOINTS.TABLET_AND_DOWN}) {
    max-height: 600px;
  }
`;

export const IconContainer = styled.div`
  align-items: center;
  backdrop-filter: blur(5px);
  background: #c2c6cb;
  border-radius: 6px;
  display: flex;
  flex-shrink: 0;
  height: 32px;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 32px;

  svg {
    color: white;
    z-index: 3;
  }
`;

export const IconFillContainer = styled.div<{
  $isActive: boolean;
  $playbackLimit: number;
}>`
  ${({ $isActive, $playbackLimit }) =>
    $isActive &&
    css`
      animation: progress ${$playbackLimit}s linear;
      animation-fill-mode: forwards;
      height: 100%;
      width: 100%;
      background: #006fff;
      position: absolute;
      left: 0;
      transform: translateX(-100%);
      z-index: 2;

      @keyframes progress {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(0);
        }
      }
    `}
`;

export const StatusBarContainer = styled.div`
  background: rgba(255, 255, 255, 0.6);
  border-radius: 4px;
  display: flex;
  height: 3px;
  position: relative;
  width: 58px;
  overflow: hidden;
`;

export const StyledStatusBar = styled.div<{
  $shouldAnimate: boolean;
  $playbackLimit: number;
}>`
  border-radius: 4px;
  height: 3px;
  position: absolute;
  top: 0;
  transform: translateX(-100%);
  width: 100%;

  ${({ $shouldAnimate, $playbackLimit }) =>
    $shouldAnimate &&
    css`
      animation: progress ${$playbackLimit}s linear;
      animation-fill-mode: forwards;
      background: ${({ theme }) => theme.colors.primaryBlue};
    `}

  @keyframes progress {
    0% {
      transform: translateX(-100%);
    }

    100% {
      transform: translateX(0);
    }
  }
`;

export const BuyButton = styled(MicrositeBuyButton)`
  margin-top: 24px;
`;

export const GlobalInViewMonitorStyle = createGlobalStyle`
  .in-view-monitor {
    width: 100%;
  }
`;
